<template>
  <div class="collaborator-information-container">
    <b-row>
      <b-col cols="3" sm="2">
        <b-img v-if="userDetails.profilePictureUrl" class="profile-picture" :src="userDetails.profilePictureUrl" rounded="circle"
               alt="User profile picture"></b-img>

        <b-img v-else class="profile-picture" :src="require('../../../../src/assets/default_profile.png')" rounded="circle"
               alt="User profile picture"></b-img>
      </b-col>
      <b-col class="ml-3">
        <p class="collaborator-name-text">{{ userDetails.name }}</p>
        <p class="collaborator-email-address-text">{{ userDetails.email }}</p>
        <p class="collaborator-role-text">Role: {{ userRole }}</p>
      </b-col>
      <b-col class="col-2">
        <font-awesome-icon v-if="userDetails.id !== user.data.id" class="times-icon"
                           icon="times" @click="removeCollaboratorFromInvitation(userDetails)"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "InviteNewCollaboratorListCell",
    props: {
      userDetails: Object,
      userRole: String
    },
    methods: {
      removeCollaboratorFromInvitation(collaboratorObject) {
        this.$store.dispatch('setRemovedFromInvitationCollaboratorObject', collaboratorObject)
      }
    },
    computed: {
      ...mapGetters([
        "homeSelectedComponent",
        "user"
      ])
    }
  }
</script>

<style scoped>
  .collaborator-information-container {
    padding: 0.75em;
    border: 1px solid #212441;
  }

  .collaborator-information-container:not(:last-child) {
    margin-bottom: 0.75em;
  }

  .profile-picture {
    width: 5em;
    height: 5em;
  }

  .collaborator-name-text, .collaborator-email-address-text {
    margin-bottom: 0.5em;
  }

  .collaborator-role-text {
    margin-bottom: 0;
  }

  .times-icon {
    cursor: pointer;
    font-size: 1.25em;
    color: red;
  }

</style>
